import {
    setMaintenanceData,
    setCautionsData,
    setComponentTrackingData, 
    setComponentTrackingFilter,
    setSelectedMRData
} from './actions';


const dispatchHealthMaintenanceData = (dispatch: any) => (maintenanceData: any) => {
    dispatch(setMaintenanceData(maintenanceData));
};

const dispatchHealthCautionsData = (dispatch: any) => (cautionsData: any) => {
    dispatch(setCautionsData(cautionsData));
}
const dispathComponentTrackingData = (dispatch: any) => (componentTrackingData: any) => {
    dispatch(setComponentTrackingData(componentTrackingData));
}
const dispathcomponentTrackingfilter = (dispatch: any) => (componentTrackingfilter: any) => {
    dispatch(setComponentTrackingFilter(componentTrackingfilter));
}
const dispatchSelectedMRData = (dispatch: any) => (selectedMRdata: any) => {
    dispatch(setSelectedMRData(selectedMRdata));
}

const operations = {
    dispatchHealthMaintenanceData,
    dispatchHealthCautionsData,
    dispathComponentTrackingData,
    dispathcomponentTrackingfilter,
    dispatchSelectedMRData    
};

export default operations;
